import { PlayerApi } from '../../communication/player-api/PlayerApi'
import { BonusStatus } from '../../communication/PlayerApiProtocol.generated'
import { hasExpired, ReduxAction } from '../ReduxUtils'
import { ApplicationState, dispatch } from '../Store'

export const REQUEST_ACCOUNTS = 'REQUEST_ACCOUNTS'
export const RECEIVE_ACCOUNTS = 'RECEIVE_ACCOUNTS'
export const ENABLE_REFRESHING_ACCOUNTS = 'ENABLE_REFRESHING_ACCOUNTS'
export const ACCOUNTS_ERROR = 'ACCOUNTS_ERROR'
export const PASS_SLOTS_PLAY_RESULTS = 'PASS_SLOTS_PLAY_RESULTS'
export const PASS_UPDATE_TOOLBAR_BALANCE = 'PASS_UPDATE_TOOLBAR_BALANCE'
export const HIDE_TOOLBAR_BALANCE = 'HIDE_TOOLBAR_BALANCE'
export const SHOW_TOOLBAR_BALANCE = 'SHOW_TOOLBAR_BALANCE'

export const fetchAccounts = (force?: boolean) => {
	return new Promise((callback) => {
		dispatch(_fetchAccounts(force, callback) as any)
	})
}

function _fetchAccounts(force?: boolean, callback?: (value: any) => void) {
	return (dispatch, getState: () => ApplicationState) => {
		const expiresInSeconds = 30
		const account = getState().player.account
		if (!hasExpired(force, account, expiresInSeconds)) {
			callback(null)
			return
		}

		dispatch(requestAccounts())

		return PlayerApi.requestBonusInfo((info: BonusStatus) => {
			dispatch(receiveAccounts(info))
			setTimeout(dispatch, (expiresInSeconds * 1000 ), enableRefreshingAccounts())
			callback(null)
		},() => {
			dispatch(accountsError())
			dispatch(enableRefreshingAccounts())
		})
	}
}
function accountsError(): ReduxAction<{}> {
	return {
		type: ACCOUNTS_ERROR,
		payload: {},
		createdTime : Date.now(),
	}
}

function requestAccounts(): ReduxAction<{}> {
	return {
		type: REQUEST_ACCOUNTS,
		payload: {},
		createdTime : Date.now(),
	}
}

export function receiveAccounts(accounts: BonusStatus): ReduxAction<BonusStatus> {
	return {
		type: RECEIVE_ACCOUNTS,
		payload: accounts,
		createdTime : Date.now(),
	}
}

export function enableRefreshingAccounts(): ReduxAction<{}> {
	return {
		createdTime : Date.now(),
		payload: {},
		type: ENABLE_REFRESHING_ACCOUNTS,
	}
}
